import React from "react";
import { twMerge } from "tailwind-merge";

const Status = ({ isActive = false }) => {
  return (
    <div
      className={twMerge(
        "font-medium uppercase tracking-wider",
        isActive
          ? "text-green-600 dark:text-green-300"
          : "text-red-600 dark:text-red-300"
      )}
    >
      {isActive ? "Active" : "Inactive"}
    </div>
  );
};

export default Status;
